export default __webpack_public_path__ + "34cae7a362d988c96843ce7d259557c7.png";